// @flow
import React, { Component } from 'react';
import { type Element as ReactElement } from 'react';
import {
  SummaryDiv,
  SummaryHeaderDiv,
  SummaryHeaderH5,
  SummaryHeaderP,
  TransactionDetailsDiv,
  HorizontalRule,
  SummaryDataDiv
} from './TableComponentStyles';

type Props = {
  options: {
    titleColor?: string,
    title1: string,
    title2?: string,
    subTitle?: string,
    hasHorizontalRule?: boolean
  },
  TableSummaryColumn: Array<ReactElement<any>>,
  TableSummaryFooter?: Array<ReactElement<any> | boolean>
};

export default class TableSummary extends Component<Props> {
  static defaultProps = {
    TableSummaryColumn: [],
    TableSummaryFooter: [],
    options: {}
  };

  render() {
    const hasFooter =
      this.props.TableSummaryFooter && this.props.TableSummaryFooter.length > 0;
    const hasHorizontalRule = this.props.options.hasHorizontalRule;
    return (
      <SummaryHeaderDiv hasHorizontalRule={hasHorizontalRule}>
        <TransactionDetailsDiv>
          <h5>{this.props.options.title1}</h5>
          <SummaryHeaderH5 color={this.props.options.titleColor}>
            {this.props.options.title2}
          </SummaryHeaderH5>
        </TransactionDetailsDiv>
        <SummaryHeaderP>{this.props.options.subTitle}</SummaryHeaderP>
        <SummaryDiv>
          <SummaryDataDiv hasFooter={hasFooter}>
            {this.props.TableSummaryColumn.map(item => item)}
          </SummaryDataDiv>
          {hasHorizontalRule && <HorizontalRule />}
          {this.props.TableSummaryFooter || [].map(item => item)}
        </SummaryDiv>
      </SummaryHeaderDiv>
    );
  }
}
